import * as React from 'react';
import { IconClose12 } from '@cian/ui-kit/icons';

import * as styles from './ClearButton.css';

interface IClearButtonProps {
  onClick(): void;
}

export const ClearButton: React.FC<IClearButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['button']} onClick={onClick} aria-label="Очистить" type="button">
      <IconClose12 />
    </button>
  );
};
